"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _bluebird = _interopRequireDefault(require("bluebird"));
var _lodash = _interopRequireDefault(require("lodash"));
var _basic = _interopRequireDefault(require("./_basic"));
class PasswordApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl
    } = _ref;
    super({
      userTokenFactory
    });
    this.sdkApiUrl = sdkApiUrl;
  }
  async startResetPassword(email, redirectPath) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(`${this.sdkApiUrl}/password/forgot-start`, {
      email,
      redirectPath
    }, headers).then(response => _bluebird.default.resolve(response.data))).catch(error => {
      error.body = {
        message: _lodash.default.get(error, 'response.data.message')
      };
      throw error;
    });
  }
  async endResetPassword(email, key, password, type) {
    const headers = await this.getHeaders();
    return _bluebird.default.try(() => _axios.default.post(`${this.sdkApiUrl}/password/forgot-end`, {
      email,
      key,
      password,
      type
    }, headers).then(response => _bluebird.default.resolve(response.data)));
  }
  async createMultiUser(_ref2) {
    let {
      token,
      type,
      password
    } = _ref2;
    return _bluebird.default.try(() => _axios.default.post(`${this.sdkApiUrl}/multi-user/create-finish`, {
      token,
      type,
      password
    }, {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    }).then(response => _bluebird.default.resolve(response.data))).catch(error => {
      error.body = {
        message: _lodash.default.get(error, 'response.data.message')
      };
      throw error;
    });
  }
}
var _default = PasswordApi;
exports.default = _default;